import { render, staticRenderFns } from "./ClearLocalStorage.vue?vue&type=template&id=3fdcca72"
import script from "./ClearLocalStorage.vue?vue&type=script&lang=js"
export * from "./ClearLocalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports